import api from "!../../../../../../../wpwootable/compile-files/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../../../wpwootable/compile-files/node_modules/css-loader/dist/cjs.js!../../../../../../../wpwootable/compile-files/node_modules/sass-loader/dist/cjs.js!./blockFactory.scss";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};